import axios from "axios";

// Private back office address (not linked anywhere on the public site)
export const ADMIN_BASE = "/crm-42406b12";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

// Access cookie lasts 15 min; on a 401 try the refresh cookie once, then retry.
api.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config;
  if (err.response?.status === 401 && cfg && !cfg._retried && !cfg.url.startsWith("/auth/")) {
    cfg._retried = true;
    await api.post("/auth/refresh");
    return api(cfg);
  }
  throw err;
});

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return typeof d?.msg === "string" ? d.msg : String(d);
};

export const STAGES = [
  { id: "new", label: "New" },
  { id: "contacted", label: "Contacted" },
  { id: "inspected", label: "Inspected" },
  { id: "estimate_sent", label: "Estimate sent" },
  { id: "won", label: "Won" },
  { id: "lost", label: "Lost" },
];
export const stageLabel = (id) => STAGES.find((s) => s.id === id)?.label ?? "New";
export const money = (n) => (n == null ? "—" : `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`);
export const shortDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "");
